import groupSeparator from '../../internal/groupSeparator';
/**
 * @see https://sail.stripe.me/apis/navigation/prefix
 */ export default function prefix(id, routePrefix, routes) {
    const prefixedRoutes = {};
    for(const name in routes){
        if (routes.hasOwnProperty(name)) {
            const pathOrPathWithSearch = routes[name];
            const path = typeof pathOrPathWithSearch === 'string' ? pathOrPathWithSearch : pathOrPathWithSearch[0];
            const prefixedRoute = routePrefix.replace(/:/g, `:${id}${groupSeparator}`) + path;
            if (typeof pathOrPathWithSearch === 'string') {
                prefixedRoutes[name] = prefixedRoute;
            } else {
                prefixedRoutes[name] = [
                    prefixedRoute,
                    pathOrPathWithSearch[1]
                ];
            }
        }
    }
    return prefixedRoutes;
}

//# sourceMappingURL=prefix.js.map